import React from 'react'
import PageBanner from '../Components/PageBanner'
import bannerBg from '../assets/img/Banners/about-us-banner-1.jpg';
import BlogTwo from '../Components/Blog/BlogTwo';

const Blogs = () => {
  return (
    <>
       <PageBanner title='Blogs' bannerBg={bannerBg} currentPage='Blogs' />
       <BlogTwo/>
    </>
  )
}

export default Blogs
